import { render, staticRenderFns } from "./ApprovalTree.vue?vue&type=template&id=30877efa&scoped=true&"
import script from "./ApprovalTree.vue?vue&type=script&lang=js&"
export * from "./ApprovalTree.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalTree.vue?vue&type=style&index=0&id=30877efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30877efa",
  null
  
)

export default component.exports